import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConsultaPaginada, ConsultaPaginadaResultado } from 'maestro-ng';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseService } from '../services/base-service.service';
import { NovoUsuarioSistema } from './novo-usuario-sistema.model';
import { Usuario } from './usuario.model';

@Injectable()
export class UsuarioService extends BaseService<Usuario, number> {
  constructor(http: HttpClient) {
    super('usuario', http);
  }

  public autenticarUsuario(login: string, senha: string): Promise<string> {
    const body = new HttpParams()
      .set('login', login)
      .set('senha', senha)
      .set('incluirPermissoes', 'true')
      .set('duracaoTokenEmMinutos', environment.duracaoTokenEmMinutos.toString());

    return firstValueFrom(
      this.http.post(this.path('autenticarUsuario'), body, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        responseType: 'text',
      })
    );
  }

  public autenticarUsuarioViaToken(token: string): Promise<string> {
    const body = new HttpParams()
      .set('kc-token', token)
      .set('incluirPermissoes', 'true')
      .set('duracaoTokenEmMinutos', environment.duracaoTokenEmMinutos.toString());

    return firstValueFrom(
      this.http.post(this.path('autenticarUsuarioViaToken'), body, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        responseType: 'text',
      })
    );
  }

  public renovaToken(token: string): Promise<string> {
    return firstValueFrom(
      this.http.get(this.path(`renovarToken/${token}/${environment.duracaoTokenEmMinutos}`), { responseType: 'text' })
    );
  }

  public recuperarPaginado(consulta: ConsultaPaginada): Promise<ConsultaPaginadaResultado<Usuario>> {
    const url = this.path('recuperarPaginado');
    return firstValueFrom(
      this.http.post<ConsultaPaginadaResultado<Usuario>>(url, consulta, { headers: this.createJsonHttpHeaders() })
    );
  }

  public recuperarSugestoes(termo: string): Promise<Usuario[]> {
    return this.service.recuperarSugestoes(termo);
  }

  public inserirNovoUsuarioSistema(dadosNovoUsuarioSistema): Promise<NovoUsuarioSistema> {
    return firstValueFrom(this.http.post<NovoUsuarioSistema>(this.path('inserirUsuarioSistema'), dadosNovoUsuarioSistema));
  }

  public alterarSenhaUsuarioSistema(dadosUsuarioSistema): Promise<NovoUsuarioSistema> {
    return firstValueFrom(this.http.patch<NovoUsuarioSistema>(this.path('alterarSenhaUsuarioSistema'), dadosUsuarioSistema));
  }

  public recuperarPorId(id: number): Promise<Usuario> {
    return firstValueFrom(this.http.get<Usuario>(this.path(`${id}`)));
  }

  public importarUsuarioSistema(login: string): Promise<NovoUsuarioSistema> {
    return firstValueFrom(
      this.http.post<NovoUsuarioSistema>(this.path(`importarUsuarioSistema/${login}`), undefined, {
        headers: this.createJsonHttpHeaders(),
      })
    );
  }
}
